import { Cache } from '../utils'

export class DrupalProvider {
    public static async fetchApi(url: string, shieldAuthorization: string | null, useCache: boolean, debug: boolean): Promise<any> {
        let data: any
        if (useCache) {
            if (debug){
                console.log(`Check cache for API ${url}`)
            }
            data = Cache.get(url)
        }

        if (!data) {
            data = await this.fetchData(url, shieldAuthorization, debug)
            if (useCache) {
                Cache.set(url, data)
            }
        }

        return data
    }

    /**
     * This function is used to convert
     * language from NC2 to standard ISO code
     * @param source the NC2 language code
     * @returns the ISO language code
     */
    public static transformLanguageFromNC2StyleToISOStyle(source: string, debug: boolean): string {
        const lSource = source.toLowerCase();
        if (lSource == 'se'){ // sweden
            if (debug){
                console.log(`Language exception se->sv`)
            }
            return 'sv';
        }
        return lSource;
    }

    public static getDataUrl(element: HTMLElement, debug: boolean): string | null {
        const lang = DrupalProvider.transformLanguageFromNC2StyleToISOStyle(document.documentElement.lang, debug) // Get the language from the document
        
        let url = element.getAttribute('data-url')

        // Check for a language-specific URL (e.g., data-url-en, data-url-fr)
        if (lang) {
            const langSpecificUrl = element.getAttribute(`data-url-${lang}`)
            if (langSpecificUrl) {
                url = langSpecificUrl // Use the language-specific URL if it exists
            }
        }

        return url
    }

    public static getDataShieldAuthorization(element: HTMLElement, debug: boolean): string | null {
        if (element.hasAttribute("data-url-authorization")){
            let authorization = element.getAttribute('data-url-authorization')
            /** remove the attribute after usage - to limit visibility of this value (even if the value is still present in the source of the page) **/
            element.removeAttribute("data-url-authorization")
            if (debug){
                console.log(`Add authorization before fetching data`)
            }
            return authorization
        }

        return null;
    }

    public static getContainers(debug: boolean): NodeListOf<HTMLElement> {
        if (debug){
            console.log(`Search .nespresso-container`)
        }
        return document.querySelectorAll('.nespresso-container') as NodeListOf<HTMLElement>
    }

    public static async fetchData(url: string, shieldAuthorization: string | null, debug: boolean): Promise<any> {
        let params = {}
        if (shieldAuthorization != null){
            params = {
                headers: {
                    Authorization: shieldAuthorization
                }
            }
        }
        if (debug){
            console.log(`Fetch data from API ${url}`)
        }
        const response = await fetch(url, params)
        if (!response.ok) {
            throw new Error(`Failed to fetch data from ${url}`)
        }
        return await response.json()
    }
}
